import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
    selector: 'app-modal-login-lupa-password',
    templateUrl: './modal-login-lupa-password.component.html',
    styleUrls: ['./modal-login-lupa-password.component.scss'],
    standalone: false
})
export class ModalLoginLupaPasswordComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<ModalLoginLupaPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }
  onClose(){
    this.dialog.close();
  }

}
